@if (categoryCode || productCode) {
  @if (categoryLinkData | async; as data) {
    <boels-generic-link
      [target]="link?.target | urlTarget"
      [isExternal]="isExternal"
      role="button"
      class="{{ applyClass }}"
      [url]="data"
    >
      <ng-container *ngTemplateOutlet="content"></ng-container>
      @if (showLink) {
        {{ link?.linkName ? link?.linkName : componentData.title }}
      }
      @if (showArrow) {
        <fa-icon
          class="small"
          [icon]="arrowType ? arrowType : iconType"
        ></fa-icon>
      }
    </boels-generic-link>
  }
} @else {
  <boels-generic-link
    [class.card__link--dark]="componentData.titleColor === backgroundColor.GREY"
    [isExternal]="isExternal"
    [target]="link?.target | urlTarget"
    [url]="link?.url"
    [class]="applyClass"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
    @if (showLink) {
      {{ link?.linkName ? link?.linkName : componentData.title }}
    }
    @if (showArrow) {
      <fa-icon
        class="small"
        [icon]="arrowType ? arrowType : iconType"
      ></fa-icon>
    }
  </boels-generic-link>
}

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
